import React, { Component, useState, useEffect, useContext } from "react";
import '../../styles.css';
import { alert_error, alert_success } from '../../AppContext';
import { FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import { limit, getDocs, orderBy } from 'firebase/firestore'
import {
  auth,
  doc,
  where,
  query,
  collection,
  db,
  onSnapshot,
} from "../../js/firebase.js";
import AdSense from 'react-adsense';
import { Link, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Cookies } from '../../index.js';
import StatusBadge from "../../js/buttonstatus.jsx";
import { ClipLoader, PulseLoader } from 'react-spinners';
import axios from "axios";
import queryString from 'query-string';
import ToggleButton from '../../app_structure/toggleButton';
import { useParams } from "react-router-dom";
function Thuongmai(props) {
  const [service, setservice] = useState(useParams());
  const [nutxuly, setnutxuly] = useState(0);
  const [hiendanhsach, sethiendanhsach] = useState(true);
  const [buttonTextjop, setbuttonTextjop] = useState("Xác nhận");
  const [timkiem, settimkiem] = useState(false);
  const [inputlienket, setinputlienket] = useState('');
  const [chedo, setchedo] = useState('baohiem');
  const [data, setData] = useState([]);
  const options = [
    { text: 'Chọn 1 chế độ tìm kiếm', value: '' },
    { text: 'Tìm theo liên kết', value: 'getlienket' },
    { text: 'Tìm theo id', value: 'getid' }
  ];

  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };
  function handleToggle(isOn) {
    setbuttonloadlist(true);
    if (isOn) {

      setchedo('baohiem');
    } else {
      setchedo('time');

    }
    laynhatky();
  }

  function testFunction(response) {
    if (response.data != '') {
      setnutxuly(0);
      setbuttonTextjop('xác nhận');
      setdulieudonhang(response.data);
      setbuttonloadlist(false);
      settimkiem(false);
      sethiendanhsach(false);
    }
    else {
      setnutxuly(0);
      setbuttonTextjop('xác nhận');
      alert_error('Không tìm thấy dữ liệu');
    }
  };
  function handleSubmit(event) {
    const myCookieValue = Cookies.get('apikey');
    event.preventDefault();
    setnutxuly(1);
    setbuttonTextjop('Please wait a moment 😊');
    if (!inputlienket || !chedo) {
      alert('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setbuttonTextjop('điền đủ thông tin');
      return
    }
    else {
      axios.get(
        'https://hust.media/nhatkyorders.php?' + chedo + '=' + inputlienket + '&apikey=' + myCookieValue)
        .then(response => (testFunction(response)))
        .catch(error => console.log(error))
    }

  }
  const [buttonloadlist, setbuttonloadlist] = useState(true);
  const totalPages = 5; // tổng số trang
  const values = queryString.parse(window.location.search);
  const currentPagephu = values.listtrang
  const [currentPage, setcurrentPage] = useState(1);
  // tạo một mảng chứa các số trang từ 1 đến totalPages
  const [pageNumbers, setpageNumbers] = useState(Array.from({ length: totalPages }, (_, i) => i + 1));

  const [dulieudonhang, setdulieudonhang] = useState([
    {
      id: 1,
      start_count: 100,
      remains: 50,
      service_name: "Đang tải danh sách vui lòng đợi",
      url: "Đang tải danh sách vui lòng đợi",
      amount: 10,
      money: 100,
      note: "Note 1",
      updatedate: "2023-04-05",
    }
    // Thêm dữ liệu vào đây
  ]);
  const fetchData = async (ok) => {
    const collectionRef = collection(db, 'users');
    const service = new URLSearchParams(window.location.search).get('service');

    if (chedo === 'baohiem') {
      let query1 = query(
        collectionRef,
        where('service', '==', ok),
        where('baohiem', '!=', ''),
        orderBy('baohiem', 'desc'),
        limit(100)
      );
      const query1Snapshot = await getDocs(query1);
      const docs1 = query1Snapshot.docs.map((doc) => doc.data());

      setdulieudonhang(docs1);
      setbuttonloadlist(false);
    } else if (chedo === 'time') {
      let query1 = query(
        collectionRef,
        where('service', '==', ok),
        where('createdate', '!=', ''),
        orderBy('createdate', 'desc'),
        limit(100)
      );
      const query1Snapshot = await getDocs(query1);
      const docs1 = query1Snapshot.docs.map((doc) => doc.data());
      setdulieudonhang(docs1);

      setbuttonloadlist(false);
    }


  };
  const laynhatky = async () => {

    const myCookieValue = Cookies.get('apikey');
    const values = queryString.parse(window.location.search);
    const listtrang = values.listtrang || 1;

    setcurrentPage(values.listtrang);


    try {
      fetchData(service.id);


    } catch (error) {

    }
  };


  const location = useLocation();
  useEffect(() => {
    setbuttonloadlist(true);

    // Xử lý sự kiện khi location thay đổi, ví dụ:
    console.log(service.id);
    console.log('Đã thay đổi đường dẫn:', location.pathname);
    laynhatky();
  }, [location]);

  // render component

  return (
    <>

      <div className="max-h-16">
        <div className="cards">
          <AdSense.Google
            client="ca-pub-4574266110812955"
            slot="1627514116"
            style={{ display: 'block' }}
            format='horizontal'
            responsive='false'
          /></div>
      </div>
      <div className="mb-2" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        Bảo hiểm  <ToggleButton onToggle={handleToggle} isOnload='no' /> Mới nhất </div>
      {timkiem ? (<>   <form className="add-form">

        <div className="form-control">
          <select
            id="countries2"
            className="selectpicker sp1 form-control"
            onChange={(e) => setchedo(e.target.value)}
          >
            {options.map((option) => (
              <option key={option.value}
                value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
          <label>Nhập cần tìm kiếm</label>
          <br />
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              Search
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Điền từ khóa"
              aria-label="inputlienket"
              value={inputlienket}
              name="inputlienket"
              aria-describedby="addon-wrapping"
              onChange={e => setinputlienket(e.target.value)}
            />
          </div>

        </div>
        <br></br>


        <br></br>
        <button onClick={handleSubmit}
          className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
          <div className='flex items-center justify-between flex-1'>
            {nutxuly == 1 && (
              <div className="spinner-border" role="status">

              </div>
            )}


            <span className='text-lg font-medium text-white'>
              {buttonTextjop} </span>
              <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
          </div>
        </button>

      </form></>) : (<>
        {hiendanhsach && (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {/* <nav>
   <ul className="pagination">
     {pageNumbers.map((pageNumber) => (
       <li key={pageNumber} className={`page-item ${pageNumber == currentPage ? 'active' : ''}`}>
         <Link to={`/reactapp/nhatkyorders?listtrang=${pageNumber}`} className="page-link">
           {pageNumber}
         </Link>
       </li>
     ))}
   </ul>
 </nav> */}
          </div>
        )}
        <div className="container-fluid mt--9">

          <div className="row">

            <div className="col-xl-12 order-xl-2 mb-5 mb-xl-0">

              <div style={{ textAlign: "center" }} className="mt-0   justify-center items-center">

                <Link to="/reactapp/baohiem" >
                  <button type="button" className="bg-gray-400 text-white btn-sm btn-outline-secondary">Đăng bài bán hàng</button></Link>
              </div>
              {
                buttonloadlist ? (
                  <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">

                    <ClipLoader color="#fff" size={150} />
                  </div>) : (
                  <>
                    {
                      dulieudonhang == '[]' || dulieudonhang == '' || !dulieudonhang ? (<h2>Dịch vụ chưa có shop đăng bài</h2>)
                        : (<></>)}
                    <div className="table-responsive overflow-x-hidden">
                      <table className="table align-middle table-flush table-sm table-bordered">
                        <thead className="thead-light" >
                          <tr>
                            <th className="text-lowercase text-center" style={{ width: "10%" }} scope="row">
                              idhustmedia
                            </th>
                            <th className="text-center" style={{ width: "10%" }} scope="row">
                              DỊCH VỤ
                            </th>
                            <th className="text-lowercase text-center" style={{ width: "25%" }} scope="col">
                              Liên kết mua hàng
                            </th>
                            <th className="text-center" style={{ width: "10%" }} scope="row">
                              Bảo hiểm
                            </th>
                            <th className="text-center" style={{ width: "10%" }} scope="col">
                              THỜI GIAN
                            </th>
                          </tr>
                        </thead>
                        <tbody>

                          {dulieudonhang.map((item, index) => {
                            const createdateok = item.createdate.toDate(); // Chuyển đổi createdate thành đối tượng Date
                            const createdate = createdateok.toLocaleDateString('vi-VN'); // Chuyển đổi đối tượng Date thành chuỗi ngày tháng


                            return (
                              <tr key={index}>
                                <td className="text-center">
                                  <Link to={"/shop/profile/" + item.username}>
                                    <span className="text-lowercase bg-danger badge rounded-pill text-wrap">
                                      <b className="text-white">{item.username}</b>
                                    </span>

                                  </Link>


                                </td>
                                <td className="text-center">
                                  <p className="text-sm">{item.caption}</p>
                                </td>
                                <td >
                                  <div style={{ width: "100%" }} className="text-center text-xs text-lowercase  bg-danger badge rounded-pill text-wrap">
                                    {item.lienket}
                                  </div>
                                  <div className="text-lowercase inline-flex " >
                                    <button onClick={() => saochep(item.lienket)} className="mr-2">
                                      <FaCopy className="inline-block mr-1 h-2 w-2 text-lowercase " />
                                      <span className="text-xs">Sao chép</span>
                                    </button>
                                    <a href={item.lienket} target="_blank" rel="noopener noreferrer" className="text-decoration-none inline-flex items-center bg-green-200 hover:bg-blue-300 py-0 px-0 rounded">
                                      <FaExternalLinkAlt className="inline-block mr-1 h-3 w-3 text-lowercase" />
                                      <span className="text-xs">Mở trang</span>
                                    </a>

                                  </div>

                                </td>
                                <td className="text-center">

                                  <b style={{ color: "blue" }}>{item.baohiem}</b> Coins

                                </td>
                                <td className="text-center">
                                  <div style={{ width: "100%" }} className="text-lowercase text-wrap">
                                    {createdate}
                                    <br />
                                    <div
                                      className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                      dangerouslySetInnerHTML={{ __html: item.note }}
                                    ></div>
                                    <br />

                                  </div>
                                </td>
                              </tr>);
                          })}
                        </tbody>
                      </table>
                    </div> </>
                )
              }

            </div>
          </div></div>
      </>)}

    </>
  );
};

export default Thuongmai;
